import React, { useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import AppLayout from './components/AppLayout';
import Dashboard from './views/Dashboard';
import Users from './views/Users';
import Analytics from './views/Analytics';
import Reports from './views/Reports';
import Settings from './views/Settings';
import Login from './views/Login';
import './App.css';

const CLIENT_ID = '518790055005-srl0gspgc7714h07t5qhikc19sqof60u.apps.googleusercontent.com';

function App() {
  const [darkMode, setDarkMode] = useState(false);
  const toggle = () => setDarkMode((d) => !d);

  return (
    <GoogleOAuthProvider clientId={CLIENT_ID}>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login darkMode={darkMode} onToggleDark={toggle} />} />
            <Route element={<ProtectedRoute />}>
              <Route element={<AppLayout darkMode={darkMode} onToggleDark={toggle} />}>
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/users"     element={<Users />} />
                <Route path="/analytics" element={<Analytics />} />
                <Route path="/reports"   element={<Reports />} />
                <Route path="/settings"  element={<Settings />} />
              </Route>
            </Route>
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </GoogleOAuthProvider>
  );
}

export default App;
